// Contesting Pose
export type ContestingPose = (typeof ContestingPose)[keyof typeof ContestingPose];

export const ContestingPose = {
  UNKNOWN: 'UNKNOWN',
  HANDS_DOWN: 'HANDS_DOWN',
  HANDS_UP: 'HANDS_UP',
};

export function isContestingPose(arg: unknown): arg is ContestingPose {
  return Object.values(ContestingPose).includes(arg as ContestingPose);
}

// Shot Contention
export type ShotContention = (typeof ShotContention)[keyof typeof ShotContention];

export const ShotContention = {
  UNKNOWN: 'UNKNOWN',
  CONTESTED: 'CONTESTED',
  UNCONTESTED: 'UNCONTESTED',
} as const;

export function isShotContention(arg: unknown): arg is ShotContention {
  return Object.values(ShotContention).includes(arg as ShotContention);
}

export function isShotContentionArray(arg: unknown): arg is ShotContention[] {
  return Array.isArray(arg) && arg.every(isShotContention);
}
